import { z } from 'zod';

const filterCommonFieldsZod = z.object({
  paramName: z.string(),
  displayName: z.string(),
  tooltip: z.string().optional(),
  disableIfFieldIsFalsy: z.string().optional(),
});

const selectFilterZod = filterCommonFieldsZod.merge(
  z.object({
    filterType: z.literal('select'),
    // Unique to Select:
    options: z.array(
      z.union([
        z.string(),
        z.object({
          label: z.string(),
          value: z.string(),
        }),
      ])
    ),
    mode: z.union([z.literal('multiple'), z.literal('tags')]),
  })
);

const textFilterZod = filterCommonFieldsZod.merge(
  z.object({
    filterType: z.literal('text'),
    // Unique to Text:
    isMulti: z.boolean().optional(),
  })
);

const numberFilterZod = filterCommonFieldsZod.merge(
  z.object({
    filterType: z.literal('number'),
    // Unique to Number:
    minValue: z.number(),
    maxValue: z.number(),
    defaultValue: z.number().optional(),
    decimalPlaces: z.number(),
  })
);

const toggleFilterZod = filterCommonFieldsZod.merge(
  z.object({
    filterType: z.literal('toggle'),

    defaultValue: z.boolean().optional(),
  })
);

const dateRangeFilterZod = filterCommonFieldsZod.merge(
  z.object({
    filterType: z.literal('dateRange'),
  })
);

// The 'filterType' property is used as the discriminator for the union
export const allFiltersZod = z.discriminatedUnion('filterType', [
  selectFilterZod,
  textFilterZod,
  numberFilterZod,
  toggleFilterZod,
  dateRangeFilterZod,
]);

// Export the Zod schema for the full array of filters
export const omnitagFiltersRespZod = z.object({
  filters: z.array(allFiltersZod),
});

export type OmnitagFilter = z.infer<typeof allFiltersZod>;
export type OmnitagFiltersResp = z.infer<typeof omnitagFiltersRespZod>;
